import {
	AfterViewInit,
	Component,
	DestroyRef,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { AlertController, ModalController } from '@ionic/angular';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import RepositoryInterface from '../../../smoothr-web-app-core/directives/repository-directive';
import { OrderListAction } from '../../enums/OrderListAction';
import { AppComponent } from '../../app.component';
import { ModalInfoComponent } from '../modal-info/modal-info.component';
import { CheckoutModalComponent } from '../checkout-modal/checkout-modal.component';
import { OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import Article from '../../../smoothr-web-app-core/models/Article';
import ArticleOption from '../../../smoothr-web-app-core/models/ArticleOption';
import { MenuPage } from '../../pages/menu/menu.page';
import Order from '../../../smoothr-web-app-core/models/Order';
import { PromoCodeType } from '../../../smoothr-web-app-core/models/PromoCodeType';
import {
	defaultsToArticleOption,
	getBasePrice,
	maxFskOfOrder,
	numberD,
	numberToCurrency,
	sleep,
} from '../../../smoothr-web-app-core/utils/utils';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import { NoteArticleModalComponent } from '../note-article-modal/note-article-modal.component';
import { NavigationService } from 'src/app/services/navigation.service';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';
import { SwiperOptions } from 'swiper/types';
import { OrderType } from 'src/smoothr-web-app-core/enums/OrderType';
import { debounceTime } from 'rxjs';
import { Api } from 'src/smoothr-web-app-core/api/api';
import { Company } from 'src/smoothr-web-app-core/models/CompanyCode';
import { environment } from 'src/environments/environment';
import { BrazeEvents, BrazeService } from '../../services/braze.service';
import { TimeUtils } from '../../../smoothr-web-app-core/utils/time-utils';
import Hours from '../../../smoothr-web-app-core/models/Hours';

@Component({
	selector: 'app-order-content',
	templateUrl: './order-content.component.html',
	styleUrls: ['order-content.component.scss'],
})
export class OrderContentComponent extends RepositoryInterface implements OnInit, AfterViewInit {
	moment = moment;

	isValid = false;
	loading = false;

	ou = OrderUtils;
	pt = PreorderType;
	taxesValue: string = '';
	differenceToMvo: number;
	@Input()
	fromMenu = false;
	promoError: string;
	tip = 0;
	totalPriceValue = '';
	totlaPriceBeforeDiscount = '';

	showAgeVefiried: boolean = false;
	ageVerified: boolean = false;
	recommendationArticles: Article[] = [];
	numberToCurrency = numberToCurrency;
	numberD = numberD;
	companyDisount = '';
	storeDiscount = '';
	public minFoodSpotSubsidy: number = 0;
	@Output() openCheckout = new EventEmitter<void>();
	@Output() closeOrderContent = new EventEmitter<void>();
	@ViewChild('swiperSlider') swiper: ElementRef | null;
	@ViewChild('orderedArticlesSection') orderedArticlesSection: ElementRef<HTMLElement> | null;
	calculateTaxesLoading = false;
	foodspotOrderedArticlesHeight: number | null = null;
	private foodspotVisibilityResizeObserver: ResizeObserver | null = null;
	private observedFoodspotContainer: HTMLElement | null = null;
	private observedFoodspotFirstCard: HTMLElement | null = null;
	constructor(
		public translate: TranslateService,
		protected repository: RepositoryService,
		private modalCtrl: ModalController,
		private snackbarCtrl: MatSnackBar,
		private router: Router,
		private route: ActivatedRoute,
		private alertCtrl: AlertController,
		private analytics: AnalyticsService,
		private navigationService: NavigationService,
		private brazeService: BrazeService,
		private destroyRef: DestroyRef
	) {
		super(repository);
		this.validate();
		this.destroyRef.onDestroy(() => {
			this.teardownFoodspotVisibilityObservers();
		});
	}

	get hasArticles(): boolean {
		return !!this.order && this.order.orderedArticles.length > 0;
	}

	ngOnInit() {
		super.ngOnInit();
		this.analytics.openOrderContent();
		this.repository.companyCode$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
			if (this.order?.preorder?.type === PreorderType.FOOD_SPOT) {
				this.validate();
				this.totalPrice();
			}
		});
		this.repository.recommendationList$.pipe(debounceTime(500), takeUntilDestroyed(this.destroyRef)).subscribe(recommendationArt => {
			if (this.venue && recommendationArt.length > 0) {
				this.recommendationArticles = [];
				recommendationArt = recommendationArt.map(it => {
					// it.articles = it.articles.splice(0, 2);
					return it;
				});
				const categoryArticles = [].concat(...this.venue.articleCategories.map(it => it.articles)) as Article[];
				const categoryArticlesMap = new Map(categoryArticles.map(it => [it._id, it]));
				recommendationArt.forEach(it => {
					it.articles.forEach(art => {
						if (categoryArticlesMap.has(art)) {
							this.recommendationArticles.push(categoryArticlesMap.get(art));
						}
					});
				});

				this.startAutoPlaySlider();
			} else {
				this.recommendationArticles = [];
			}
			this.scheduleFoodspotOrderListHeightCalculation();
		});
		if (this.router.url.includes('payment/fail')) {
			this.snackbarCtrl.open('Sorry,smth goes wrong with your payment', null, {
				duration: 5000,
			});
			return;
		}
	}

	ngAfterViewInit() {
		this.scheduleFoodspotOrderListHeightCalculation();
	}

	@HostListener('window:resize')
	onWindowResize() {
		this.scheduleFoodspotOrderListHeightCalculation();
	}

	private shouldKeepFirstOrderCardVisible(): boolean {
		return !AppComponent.largeScreen && this.hasArticles && (this.recommendationArticles?.length ?? 0) > 0;
	}

	private scheduleFoodspotOrderListHeightCalculation() {
		if (!this.shouldKeepFirstOrderCardVisible()) {
			this.foodspotOrderedArticlesHeight = null;
			this.teardownFoodspotVisibilityObservers();
			return;
		}

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				this.calculateFoodspotOrderListHeight();
			});
		});
	}

	private calculateFoodspotOrderListHeight() {
		if (!this.shouldKeepFirstOrderCardVisible()) {
			this.foodspotOrderedArticlesHeight = null;
			this.teardownFoodspotVisibilityObservers();
			return;
		}

		const orderedArticlesElement = this.orderedArticlesSection?.nativeElement;
		if (!orderedArticlesElement) {
			this.teardownFoodspotVisibilityObservers();
			return;
		}

		const firstOrderCard = orderedArticlesElement.querySelector('app-order-list .order-item') as HTMLElement | null;
		if (!firstOrderCard) {
			this.foodspotOrderedArticlesHeight = null;
			this.teardownFoodspotVisibilityObservers();
			return;
		}

		const orderedArticlesRect = orderedArticlesElement.getBoundingClientRect();
		const firstOrderCardBottom = firstOrderCard.getBoundingClientRect().bottom;
		const scrollOffset = orderedArticlesElement.scrollTop;
		const paddingBottom = Number.parseFloat(getComputedStyle(orderedArticlesElement).paddingBottom || '0');
		const requiredHeight = Math.ceil(firstOrderCardBottom - orderedArticlesRect.top + scrollOffset + paddingBottom);
		const nextHeight = requiredHeight > 0 ? requiredHeight : null;
		if (this.foodspotOrderedArticlesHeight !== nextHeight) {
			this.foodspotOrderedArticlesHeight = nextHeight;
		}
		this.ensureFoodspotVisibilityObservers(orderedArticlesElement, firstOrderCard);
	}

	private ensureFoodspotVisibilityObservers(container: HTMLElement, firstOrderCard: HTMLElement) {
		if (typeof ResizeObserver === 'undefined') {
			return;
		}
		if (!this.foodspotVisibilityResizeObserver) {
			this.foodspotVisibilityResizeObserver = new ResizeObserver(() => {
				this.scheduleFoodspotOrderListHeightCalculation();
			});
		}
		if (this.observedFoodspotContainer !== container) {
			if (this.observedFoodspotContainer) {
				this.foodspotVisibilityResizeObserver.unobserve(this.observedFoodspotContainer);
			}
			this.foodspotVisibilityResizeObserver.observe(container);
			this.observedFoodspotContainer = container;
		}
		if (this.observedFoodspotFirstCard !== firstOrderCard) {
			if (this.observedFoodspotFirstCard) {
				this.foodspotVisibilityResizeObserver.unobserve(this.observedFoodspotFirstCard);
			}
			this.foodspotVisibilityResizeObserver.observe(firstOrderCard);
			this.observedFoodspotFirstCard = firstOrderCard;
		}
	}

	private teardownFoodspotVisibilityObservers() {
		if (this.foodspotVisibilityResizeObserver) {
			if (this.observedFoodspotContainer) {
				this.foodspotVisibilityResizeObserver.unobserve(this.observedFoodspotContainer);
			}
			if (this.observedFoodspotFirstCard) {
				this.foodspotVisibilityResizeObserver.unobserve(this.observedFoodspotFirstCard);
			}
			this.foodspotVisibilityResizeObserver.disconnect();
		}
		this.foodspotVisibilityResizeObserver = null;
		this.observedFoodspotContainer = null;
		this.observedFoodspotFirstCard = null;
	}
	async startAutoPlaySlider() {
		try {
			await sleep(1500);
			this.swiper.nativeElement?.swiper?.update;
			this.swiper.nativeElement?.swiper?.autoplay?.start();
		} catch (e) {}
	}
	onVenue() {
		super.onVenue();
		this.validate();
	}
	onCustomer(): void {
		super.onCustomer();
	}

	onOrder() {
		super.onOrder();
		if (this.order && this.order.orderedArticles && this.order.orderedArticles.length > 0) {
			this.analytics.orderHasProducts();
		}
		this.validate();
		if (this.order) {
			this.totalPrice();
		}
		this.scheduleFoodspotOrderListHeightCalculation();
	}

	async onAction(index: number, event: OrderListAction) {
		switch (event) {
			case OrderListAction.add:
				this.order.orderedArticles[index].quantity += 1;
				this.brazeService.logCustomEvent(BrazeEvents.increase_article_count, {
					name: this.order.orderedArticles[index].article.name.en,
				});
				break;
			case OrderListAction.delete:
				if (OrderUtils.isBogoOrFreeArticlePromo(this.order) && this.order.promoCode.type === PromoCodeType.BOGO) {
					const bogoArticleIndex = this.order.orderedArticles.findIndex(ag => ag.isPromo);
					const bogoArticle = this.order.orderedArticles[bogoArticleIndex];
					const matchingBogoArticleIndices = this.order.orderedArticles
						.map((ag, agIndex) => {
							return ag.article._id === bogoArticle.article._id &&
								!ag.isPromo &&
								OrderUtils.bogoPrice(ag, this.order.type, this.order.preorder.type) ===
									OrderUtils.bogoPrice(bogoArticle, this.order.type, this.order.preorder.type)
								? agIndex
								: -1;
						})
						.filter(agIndex => agIndex !== -1);
					if (matchingBogoArticleIndices.find(bogoIndex => bogoIndex === index) !== undefined) {
						// article that should be removed is a possible parent of promoCode article
						if (matchingBogoArticleIndices.length === 1) {
							// only that article is possible parent of promoCode. If this article is removed the PromoCode and PromoArticle
							// should also be removed. Ask user.
							const bogoAlert = await this.alertCtrl.create({
								header: this.translate.instant('remove_bogo_alert.header'),
								message: this.translate.instant('remove_bogo_alert.message'),
								buttons: [
									{
										text: this.translate.instant('remove_bogo_alert.button_remove'),
										handler: () => {
											this.order.orderedArticles[bogoArticleIndex].isPromo = false;
											this.order.promoCode = null;
											this.order.orderedArticles.splice(index, 1);
											bogoAlert.dismiss();
										},
									},
									{
										text: this.translate.instant('remove_bogo_alert.button_keep'),
										handler: () => {
											bogoAlert.dismiss();
										},
									},
								],
							});
							await bogoAlert.present();
							await bogoAlert.onDidDismiss();
							break;
						}
					}
				}
				this.brazeService.logCustomEvent(BrazeEvents.remove_article, { name: this.order.orderedArticles[index].article.name.en });
				this.order.orderedArticles.splice(index, 1);
				break;
			case OrderListAction.note:
				this.noteArticle(index);
				break;
			case OrderListAction.edit:
				const modal = await this.modalCtrl.create({
					cssClass: AppComponent.largeScreen ? 'item-modal large-modal' : 'item-modal',
					component: ModalInfoComponent,
					componentProps: {
						// copy article group
						articleGroup: JSON.parse(JSON.stringify(this.order.orderedArticles[index])),
						recommend: false,
					},
					showBackdrop: true,
					backdropDismiss: true,
				});
				await modal.present();
				const response = await modal.onDidDismiss();
				if (response.data && response.data.articleGroup) {
					const promoAgIndex = this.order.orderedArticles.findIndex(oa => oa.isPromo);
					if (
						OrderUtils.isBogoOrFreeArticlePromo(this.order) &&
						this.order.promoCode.type === PromoCodeType.BOGO &&
						this.order.orderedArticles[index].article._id === this.order.orderedArticles[promoAgIndex].article._id &&
						OrderUtils.bogoPrice(response.data.articleGroup, this.order.type, this.order.preorder.type) <
							OrderUtils.bogoPrice(this.order.orderedArticles[promoAgIndex], this.order.type, this.order.preorder.type)
					) {
						this.order.orderedArticles[promoAgIndex].isPromo = false;
						const newPromoAg = JSON.parse(JSON.stringify(response.data.articleGroup));
						newPromoAg.isPromo = true;
						this.order.orderedArticles.push(newPromoAg);
					}
					this.order.orderedArticles[index] = response.data.articleGroup;
					this.repository.onOrderChange(this.order);
				}
				this.brazeService.logCustomEvent(BrazeEvents.edit_article, { name: this.order.orderedArticles[index].article.name.en });
				break;
			case OrderListAction.remove:
				if (this.order.orderedArticles[index].quantity > 1) {
					this.order.orderedArticles[index].quantity -= 1;
					this.brazeService.logCustomEvent(BrazeEvents.decrease_article_count, {
						name: this.order.orderedArticles[index].article.name.en,
					});
				} else {
					await this.onAction(index, OrderListAction.delete);
					return;
				}
				break;
		}
		this.repository.onOrderChange(this.order);
	}

	async openCheckoutModal() {
		this.validate();
		if (!this.isValid || this.loading) {
			return;
		}
		this.loading = true;
		if (AppComponent.largeScreen) {
			this.openCheckout.emit();
		}

		this.order.asap = false;
		const result = await CheckoutModalComponent.show(this.modalCtrl, this.analytics, this.order, this.tip);
		if (result.data === undefined) {
			this.loading = false;
			return;
		}
		const customer = this.repository._customerAuth?.customer;
		if (customer?.isAnonymous && customer?.email) {
			this.brazeService.initForGuestSubscription(customer);
		}
		await this.brazeService.sendBrazeEventsChunk();

		this.order.orderAt = result.data.orderAt;
		this.order.preorder = result.data.preorder;
		let companyData = null;
		const resultData = this.checkBrowserData();
		this.order.clientMeta = resultData;
		try {
			if (this.repository.companyCode$.getValue() && this.order.preorder.type === PreorderType.FOOD_SPOT) {
				this.order.dndCompany = this.repository.companyCode$.getValue()?._id ?? undefined;
				if (this.order.dndCompany) {
					companyData = this.repository.companyCode$.getValue();
				}
			}
		} catch (e) {}
		this.tip = result.data.tip;
		this.repository.onOrderChange(this.order);

		try {
			await this.repository.getVenue(this.venue?._id, true);
		} catch (e) {}

		if (!this.checkArticleAvailability(result.data.orderAt)) {
			this.loading = false;
			return;
		}

		const unavailableNames = this.getUnavailableArticleNames();
		if (unavailableNames.length > 0) {
			for (const name of unavailableNames) {
				this.snackbarCtrl.open(this.translate.instant('errors.article_no_longer_available', { name }), null, { duration: 5000 });
			}
			this.loading = false;
			return;
		}

		try {
			await this.repository.createOrderWithPayment(
				this.modalCtrl,
				this.translate,
				this.order,
				this.tip,
				loading => (this.loading = loading),
				this.snackbarCtrl,
				false,
				false,
				companyData
			);
		} catch (e) {
			console.error(e);
		}
	}

	validate() {
		if (!this.order || !this.venue || !this.order.preorder) {
			this.isValid = false;
			return;
		}
		const result = OrderUtils.validateOrder(this.venue, this.order);
		let checkSubcidyForFoodSpot = true;
		this.differenceToMvo = result.movDifference;
		const orderFSK = maxFskOfOrder(this.order);
		if (this.order?.preorder?.type === PreorderType.FOOD_SPOT) {
			let response = this.checkAvailableOrder(this.order);
			this.minFoodSpotSubsidy = response.min;
			checkSubcidyForFoodSpot = response.value;
		}
		if (orderFSK > 0) {
			this.showAgeVefiried = true;
			if (!this.ageVerified) {
				this.isValid = false;
				return;
			}
		} else {
			this.showAgeVefiried = false;
		}

		this.isValid = result.valid && checkSubcidyForFoodSpot;
	}
	checkAvailableOrder(order: Order) {
		try {
			let companyCode: Company | null = null;
			if (this.order?.preorder?.type === PreorderType.FOOD_SPOT) {
				companyCode = this.repository.companyCode$.getValue() ?? null;
				const totalPriceWithoutDiscount = OrderUtils.orderTotalPrice(this.order, false, false, null);
				if (totalPriceWithoutDiscount < numberD(companyCode.orderMinimum)) {
					return {
						value: totalPriceWithoutDiscount > numberD(companyCode.orderMinimum),
						min: numberD(companyCode.orderMinimum) - totalPriceWithoutDiscount,
					};
				}

				const totalPrice = OrderUtils.orderTotalPrice(this.order, true, true, companyCode);
				const shouldValidateSubsidyMinimum = !!(
					companyCode &&
					!companyCode.isPaidByCompany &&
					companyCode.subsidyOrderMinimum &&
					Number(companyCode.subsidyOrderMinimum) > 0
				);

				if ((totalPrice === 0 || totalPrice) && shouldValidateSubsidyMinimum) {
					return {
						value: totalPrice >= Number(companyCode.subsidyOrderMinimum),
						min: Number(companyCode.subsidyOrderMinimum) - totalPrice,
					};
				} else {
					return { value: true, min: 0 };
				}
			}
			return { value: true, min: 0 };
		} catch (e) {
			return { value: true, min: 0 };
		}
	}
	amountOfPoints() {
		return OrderUtils.orderTotalPrice(this.order, true, true) + this.tip;
	}
	mapGroup(articleGroup: ArticleGroup) {
		if (!this.venue || !this.order) {
			return articleGroup;
		}
		if (articleGroup.isHalfPizza) {
			const foundArticle = this.venue.articleCategories
				.map(it => {
					if (it.visible) {
						const foundArticle = it.articles.find(ar => ar._id === articleGroup.article._id);

						return foundArticle ?? null;
					} else {
						return null;
					}
				})
				.filter(it => !!it);
			if (foundArticle.length === 1) {
				const test = JSON.parse(JSON.stringify(articleGroup)) as ArticleGroup;
				test.article = JSON.parse(JSON.stringify(foundArticle[0]));
				return test;
			}
			return articleGroup;
		}
		return articleGroup;
	}
	private async calculateTaxes(order: Order) {
		if (this.calculateTaxesLoading) {
			return 0;
		}
		this.calculateTaxesLoading = true;
		let result = 0;
		const copyOfOrder = JSON.parse(JSON.stringify(order)) as Order;
		try {
			copyOfOrder.userUid = this.customer?.uid ?? '';
			copyOfOrder.preorder.name = 'calculate taxes';
			copyOfOrder.preorder.email = 'dnd@smoothr.de';
			copyOfOrder.preorder.number = '+49234234324';
			copyOfOrder.orderAt = moment().add(1, 'hours');
			let response: Order;
			try {
				response = (await Api.calculateTaxes(copyOfOrder)).data;
			} catch (error) {
				copyOfOrder.promoCode = null;
				response = (await Api.calculateTaxes(copyOfOrder)).data;
			}
			if (response?.totalPrice && response?.totalNetPrice) {
				result = Number(response.totalPrice) - Number(response.totalNetPrice);
			}
			this.calculateTaxesLoading = false;

			return Math.round(result * 100) / 100;
		} catch (e) {
			this.calculateTaxesLoading = false;
			return result;
		}
	}
	async totalPrice() {
		let companyCode = null;
		const order = this.order;
		if (!order) {
			this.taxesValue = '';
			this.totalPriceValue = '';
			this.totlaPriceBeforeDiscount = '';
			this.companyDisount = '';
			return;
		}
		if (order?.preorder?.type === PreorderType.FOOD_SPOT) {
			companyCode = this.repository.companyCode$.getValue() ?? null;
		}
		const resultOfTaxes = await this.calculateTaxes(order);

		this.taxesValue = numberToCurrency(resultOfTaxes, order.currency);
		const totalPrice = OrderUtils.orderTotalPrice(order, true, true, companyCode);
		this.totalPriceValue = numberToCurrency(totalPrice + this.tip, order.currency);
		this.totlaPriceBeforeDiscount = numberToCurrency(
			OrderUtils.orderTotalPrice(order, false, false) + this.tip - resultOfTaxes,
			order.currency
		);
		if (order.preorder.type === PreorderType.FOOD_SPOT) {
			const code = this.repository.companyCode$.getValue();
			this.storeDiscount = code?.storeDiscount ? (Number(code.storeDiscount) * 100).toString() + '%' : '';
			this.companyDisount =
				code && !code.isPaidByCompany && code.subsidy ? numberToCurrency(Number(code.subsidy), order.currency) : '';
		} else {
			this.storeDiscount = '';
			this.companyDisount = '';
		}
	}

	replace(index: number, article: Article, options: ArticleOption[]) {
		this.order.orderedArticles[index].quantity = 1;
		this.order.orderedArticles[index].article = article;
		this.order.orderedArticles[index].groups = options;
	}

	onPromoApplied(order: Order) {
		this.promoError = null;
		this.repository.onOrderChange(order);
	}

	onDeletePromo(order: Order) {
		this.promoError = null;
		this.repository.onOrderChange(order);
	}

	onPromoCodeError(error: string) {
		if (!error) {
			// error just resetting error no error happened
			return;
		}
		// Promo error
		this.snackbarCtrl.open(error, null, { duration: 2000 });
		this.repository.onOrderChange(OrderUtils.removePromo(this.order));

		this.promoError = error;
	}

	async backToMenu() {
		if (AppComponent.largeScreen) {
			this.close();
		} else {
			await this.navigationService.menu();
		}
		this.brazeService.logCustomEvent(BrazeEvents.add_more);
	}

	async noteArticle(index: number) {
		const modal = await this.modalCtrl.create({
			cssClass: 'short-info-modal auto-height',
			component: NoteArticleModalComponent,
			componentProps: {
				// copy article group
				articleGroup: JSON.parse(JSON.stringify(this.order.orderedArticles[index])),
				recommend: false,
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const response = await modal.onDidDismiss();
		if (response?.data || response.data === '') {
			this.order.orderedArticles[index].note = response?.data;
		}
	}

	handleChangeRadio(event: { detail: { value: string } }) {}
	login() {
		this.navigationService.signIn();
	}
	signUp() {
		this.navigationService.signUp();
	}
	checkPageIfHaveGrid(articleGroup: ArticleGroup) {
		return (
			articleGroup.article.groups.length > 0 &&
			articleGroup.article.groups.filter(it => !!it.tags.find(tag => tag.identifier === 'half_pizza')).length > 0
		);
	}
	identify(index, item) {
		return item?.group;
	}
	changeAgeVerification() {
		this.validate();
	}
	addArticle(article: Article) {}
	checkMeasurmentPlusPfand(article: Article) {
		let result = '';
		if (!this.order) {
			return;
		}
		const pfandValue = this.checkPfandTag(article);
		if (pfandValue) {
			result =
				this.translate.instant('pfand_text.zzgl') +
				(pfandValue === 'deposit15' ? numberToCurrency(0.15, this.order.currency) : numberToCurrency(0.25, this.order.currency)) +
				this.translate.instant('pfand_text.pfand') +
				'<br/>';
		} else {
			if (result.length > 0) {
				result = result + ')';
			}
		}
		if (article?.measurement && article?.measurement?.unit && article?.measurement?.amount) {
			result =
				result +
				' ' +
				article.measurement?.refAmount +
				' ' +
				article.measurement?.refUnit +
				' = ' +
				this.numberToCurrency(getBasePrice(article, OrderType.PREORDER, this.order.preorder.type), this.order.currency);
		}
		return result;
	}
	checkPfandTag(article: Article) {
		if (article.tags?.length === 0) {
			return '';
		}
		const deposit25 = article.tags.find(it => it.identifier === 'deposit25') ? 'deposit25' : '';
		const deposit15 = article.tags.find(it => it.identifier === 'deposit15') ? 'deposit15' : '';

		return deposit15 || deposit25;
	}
	close() {
		if (this.router.url.includes('payment/fail')) {
			this.navigationService.home();
			return;
		}
		if (AppComponent.largeScreen) {
			this.closeOrderContent.emit();
		} else {
			this.navigationService.menu();
		}
	}
	async openModal(item: Article) {
		if (this.loading) {
			return;
		}

		const articleGroup = new ArticleGroup();
		articleGroup.article = item;
		articleGroup.groups.push(...defaultsToArticleOption(item, [], item.defaults, this.order?.type, this.order.preorder.type));
		articleGroup.quantity = 1;

		const modal = await this.modalCtrl.create({
			cssClass: AppComponent.largeScreen ? 'item-modal large-modal' : 'item-modal',
			component: ModalInfoComponent,
			componentProps: {
				articleGroup,
			},
			mode: 'ios',
			backdropDismiss: true,
		});
		await modal.present();
		const response = await modal.onDidDismiss();
		if (response.data && response.data.articleGroup) {
			OrderUtils.addToOrder(this.order, response.data.articleGroup, this.analytics);
			this.analytics.addToCart(this.order, response.data.articleGroup);
			this.repository.onOrderChange(this.order);
		}
	}
	async navToPromo() {
		try {
			await this.modalCtrl.dismiss();
		} catch (e) {}

		this.navigationService.promo();
	}
	removePromoAndEmit() {
		if (this.order) {
			this.onDeletePromo(OrderUtils.removePromo(this.order));
		}
	}
	checkBrowserData() {
		try {
			const userAgent = navigator.userAgent;
			const platform = 'web'; // Оскільки це вебдодаток

			// Визначення браузера (можна також використати сторонні бібліотеки типу bowser)
			const browser = this.getBrowserInfo(userAgent);

			// Отримання версії ОС
			const osVersion = this.getOSVersion(userAgent);

			return {
				platform,
				appVersion: environment.version, // для веба не застосовується
				osVersion,
				browser,
				device: userAgent,
			};
		} catch (e) {}
	}
	getBrowserInfo(userAgent: string): string {
		if (userAgent.includes('Chrome')) {
			return 'Chrome';
		} else if (userAgent.includes('Firefox')) {
			return 'Firefox';
		} else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
			return 'Safari';
		} else if (userAgent.includes('Edg')) {
			return 'Edge';
		}
		return 'Unknown';
	}

	getOSVersion(userAgent: string): string {
		const osMatches = [
			{ name: 'Windows', regex: /Windows NT ([\d.]+)/ },
			{ name: 'macOS', regex: /Mac OS X ([\d_]+)/ },
			{ name: 'iPadOS', regex: /iPad.*?CPU OS ([\d_]+)/ },
			{ name: 'iOS', regex: /iPhone OS ([\d_]+)/ },
			{ name: 'Android', regex: /Android ([\d.]+)/ },
		];

		for (const os of osMatches) {
			const match = userAgent.match(os.regex);
			if (match) {
				return `${os.name} ${match[1].replace(/_/g, '.')}`;
			}
		}

		return 'unknown';
	}
	selectTip(tip: number) {
		this.tip = tip;
		this.totalPrice();
	}

	private getUnavailableArticleNames(): string[] {
		if (!this.venue || !this.order) {
			return [];
		}
		const unavailable: string[] = [];
		for (const ag of this.order.orderedArticles) {
			let isAvailable = false;
			for (const cat of this.venue.articleCategories) {
				if (!cat.visible) {
					continue;
				}
				const article = cat.articles.find(a => a._id === ag.article._id);
				if (article && article.isActive && article.visible && !article.hidden) {
					isAvailable = true;
					break;
				}
			}
			if (!isAvailable) {
				const lang = this.translate.currentLang;
				const name = (ag.article.name as unknown as Record<string, string>)[lang] || ag.article.name.de || ag.article.name.en;
				unavailable.push(name);
			}
		}
		return unavailable;
	}

	private checkArticleAvailability(orderAt: string | null): boolean {
		if (!orderAt) {
			return true;
		}
		const orderMoment = moment(orderAt);
		for (const articleGroup of this.order.orderedArticles) {
			const article = articleGroup.article;
			if (article.availableHours && article.availableHours.length > 0) {
				if (!TimeUtils.doesHoursMatch(orderMoment, article.availableHours)) {
					this.showArticleAvailabilityError(
						article.name as unknown as Record<string, string>,
						orderMoment,
						article.availableHours
					);
					return false;
				}
			}
			if (this.venue?.articleCategories) {
				for (const category of this.venue.articleCategories) {
					if (
						category.availableHours &&
						category.availableHours.length > 0 &&
						category.articles?.some(a => a._id === article._id)
					) {
						if (!TimeUtils.doesHoursMatch(orderMoment, category.availableHours)) {
							this.showArticleAvailabilityError(
								article.name as unknown as Record<string, string>,
								orderMoment,
								category.availableHours
							);
							return false;
						}
						break;
					}
				}
			}
		}
		return true;
	}

	private showArticleAvailabilityError(name: Record<string, string>, orderMoment: moment.Moment, hours: Hours[]): void {
		let weekday = orderMoment.weekday() - 1;
		if (weekday < 0) {
			weekday = 6;
		}
		const dayHours = hours.filter(h => h.weekday === weekday);
		const availabilityTime = dayHours.map(h => `${h.openedAt} - ${h.closedAt}`).join(', ');
		const articleName = name[this.translate.currentLang] || name['en'] || name['de'];
		this.snackbarCtrl.open(
			this.translate.instant('checkout_modal.article_availability_time', { articleName, availabilityTime }),
			null,
			{ duration: 5000 }
		);
	}
}
